import React, { useEffect } from "react";
import {
  APP_WINDOW_CHANNEL,
  APP_WINDOW_ELEMENT_ID,
  APP_WINDOW_HIDE_MESSAGE,
  isInAppWindow,
} from "../../utils/appWindowUtils";
import { ROOT } from "../../navigation/CONSTANTS";

/*
 * Parent iframe only. Shopify loads `src` in a second iframe that covers
 * Admin (including the left nav) after the merchant clicks Full screen.
 * Do not call .show() here — App Store rules require a click in the app body.
 *
 * Default src is required by s-app-window. The Full screen click overwrites
 * it with the current route before calling show().
 */
const AppWindowHost = () => {
  useEffect(() => {
    if (isInAppWindow()) {
      return undefined;
    }
    let channel;
    try {
      channel = new BroadcastChannel(APP_WINDOW_CHANNEL);
    } catch (err) {
      return undefined;
    }
    channel.onmessage = (event) => {
      if (event.data?.type !== APP_WINDOW_HIDE_MESSAGE) {
        return;
      }
      const win = document.getElementById(APP_WINDOW_ELEMENT_ID);
      if (win && typeof win.hide === "function") {
        win.hide();
      }
    };
    return () => {
      channel.close();
    };
  }, []);

  if (isInAppWindow()) {
    return null;
  }

  return (
    <s-app-window
      id={APP_WINDOW_ELEMENT_ID}
      src={`${ROOT}?appWindow=1`}
    ></s-app-window>
  );
};

export default AppWindowHost;
